/**
 * Agent-facing retrieve copy must never name the deeds vendor.
 * Also drop the old “Nearby … hits: 65, 50, …” dump — the dropdown shows those.
 */
export function sanitizeRetrieveCopy(text) {
    let s = String(text || '');
    s = s.replace(/No match on Lightstone for\s*[“"']([^”"']+)[”"']\.?/gi, 'No match for “$1”.');
    s = s.replace(/Nearby Lightstone hits:\s*[^.]+(\.)?/gi, '');
    s = s.replace(/Lightstone credentials are not configured[^.]*\.?/gi, 'Automated retrieval is not configured on the server.');
    s = s.replace(/\bLightstone\b/gi, '');
    s = s.replace(/^(Network Error|timeout of \d+ms exceeded|ERR_EMPTY_RESPONSE|Request failed with status code 50[234])$/i, 'The retrieve connection dropped before the report came back. Try again, or drop a PDF if you already have one.');
    s = s.replace(/Attempted to use detached Frame[^.]*\.?/gi, '');
    s = s.replace(/\s{2,}/g, ' ').replace(/\s+([.,])/g, '$1').trim();
    return s;
}

/** Append the PDF fallback once — server copy already includes it. */
export function withPdfFallback(text) {
    const s = sanitizeRetrieveCopy(text);
    if (/drop a (report )?pdf/i.test(s)) return s;
    return `${s} Drop a report PDF if you already have one.`.replace(/\s{2,}/g, ' ').trim();
}
